module.exports = __webpack_public_path__ + "loader.png?906bd902525a623d3491350af83d1e48";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader.png
// module id = 637
// module chunks = 0 1 2 3 7 8 9 10